module.exports = "<svg id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\"><style>.st0{fill:#fff}</style><path d=\"M24 15c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z\"/><path class=\"st0\" d=\"M20 14h-3v-3c0-.6-.4-1-1-1s-1 .4-1 1v3h-3c-.6 0-1 .4-1 1s.4 1 1 1h3v3c0 .6.4 1 1 1s1-.4 1-1v-3h3c.6 0 1-.4 1-1s-.4-1-1-1z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/plus.svg
// module id = 87
// module chunks = 0